import { INeighborAreaSettings, TNewNeighborAreaSettings } from "@ryde/shared";

export const getIsNeighborAreasSettingsEmpty = (
  settings: INeighborAreaSettings | TNewNeighborAreaSettings,
): boolean => {
  const isDirectionSet = Boolean(settings?.direction);
  const isFromTimeSet = Boolean(settings?.fromTime);
  const isToTimeSet = Boolean(settings?.toTime);
  const isDayGroupIdsSet = Boolean(settings?.dayGroupIds?.length);
  const isDayTypeIdsSet = Boolean(settings?.dayTypeIds?.length);

  return (
    !isDirectionSet &&
    !isFromTimeSet &&
    !isToTimeSet &&
    !isDayGroupIdsSet &&
    !isDayTypeIdsSet
  );
};

export const filterNeighborAreasSettingsToShow = (
  settings: INeighborAreaSettings | TNewNeighborAreaSettings,
): boolean => {
  const isDirectionSet = Boolean(settings?.direction);
  const isFromTimeSet = Boolean(settings?.fromTime);
  const isToTimeSet = Boolean(settings?.toTime);
  const isDayGroupIdsSet = Boolean(settings?.dayGroupIds?.length);
  const isDayTypeIdsSet = Boolean(settings?.dayTypeIds?.length);

  return (
    isDirectionSet ||
    isFromTimeSet ||
    isToTimeSet ||
    isDayGroupIdsSet ||
    isDayTypeIdsSet
  );
};
